/// <reference path='../../docs-and-forms.module.ts' />
/// <reference path='../../../../../../typings/index.d.ts' />
///<reference path="../../docs-and-forms.models.ts"/>
///<reference path="../../docs-and-forms-render.service.ts"/>

module Meevo.Plugins.DocsAndForms {
    import SecurityAccessEnum = Meevo.Model.SecurityAccessEnum;

    class DocsAndFormsBuilderPreviewChoicesComponent implements ng.IComponentController {

        static $inject = [
            '$translate',
            'meevo.components.common.SecurityService'
        ];

        public formCreatedVia: string;
        model: IDocsAndFormsModel;
        formCreationTypeEnum = DocsAndFormsCreationTypeEnum;
        openBuilderEvent: ({ builder: BuilderEnum }) => void;
        builderEnum = BuilderEnum;
        showTemplateButton: boolean;
        isIntakeForm: boolean;
        emptyFormMessage: string;
        protected editSecurityKey: string;
        isEditSecurityHidden: boolean = true;

        constructor(private $translate: ng.translate.ITranslateService,
                    private securityService: Meevo.Components.Common.ISecurityService) {
        }

        $onInit() {
            this.showTemplateButton = !this.model.formCreationTypeEnum
            && this.model.tabTypeEnum !== Meevo.Model.FormTypeEnum.Intake;
            this.isIntakeForm = this.model.tabTypeEnum === Meevo.Model.FormTypeEnum.Intake;
            this.emptyFormMessage = this.isIntakeForm
                ? 'LABEL_SELECT_CUSTOM_HTML_OR_DESIGNER_INTAKE'
                : "";

            switch (this.model.formCreationTypeEnum) {
                case DocsAndFormsCreationTypeEnum.CustomHtmlUpload:
                    this.formCreatedVia = this.$translate.instant('LABEL_FORM_CREATED_VIA', {
                        type: this.$translate.instant('LABEL_CUSTOM_HTML_UPLOAD')
                    });
                    break;

                case Meevo.Plugins.DocsAndForms.DocsAndFormsCreationTypeEnum.WYSIWYG:
                    this.formCreatedVia = this.$translate.instant('LABEL_FORM_CREATED_VIA', {
                        type: this.$translate.instant('LABEL_FORM_DESIGNER')
                    });
                    break;

                default:
                    this.formCreatedVia = this.$translate.instant('LABEL_NO_FORM_HAS_BEEN_CREATED');
            }

            this.editSecurityKey = (this.isIntakeForm
                ? Meevo.Components.Common.SecurityKeys.MANAGEMENT_CLIENTINTAKEFORMBUILDER_TAB_FORMBUILDER
                : Meevo.Components.Common.SecurityKeys.MANAGEMENT_DOCSANDFORMS_TAB_FORMBUILDER)
                + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE;

            this.securityService.checkSecurityKey(this.editSecurityKey)
                .then((securityAccess: SecurityAccessEnum) => {
                    this.isEditSecurityHidden = securityAccess === SecurityAccessEnum.Hide;
                })
                .catch(() => {
                    this.isEditSecurityHidden = true;
                });
        }

        openBuilder(builderEnum: BuilderEnum) {
            this.openBuilderEvent({ builder: builderEnum });
        }

    }

    angular.module('meevo.plugins.docsAndForms')
        .component('docsAndFormsBuilderPreviewChoicesComponent', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/docsAndForms/components/builder-preview-choices/builder-preview-choices.component.html',
            controller: DocsAndFormsBuilderPreviewChoicesComponent,
            controllerAs: '$ctrl',
            bindings: {
                model: '<',
                openBuilderEvent: '&',
            }
        });

}
